<template>
    <div class="search-results" v-click-outside="close">
        <div class="grid-container content-container grid-x grid-margin-y" v-if="!loading">
            <div class="cell">
                <h2 class="h2 text-center">
                    <translate v-if="resultsCount > 0" :translate="{resultsCount, keyword}" :translate-n="resultsCount" translate-plural='%{resultsCount} results for "%{keyword}"'>%{resultsCount} result for "%{ keyword }"</translate>
                    <translate v-else :translate="keyword">No results for "%{keyword}"</translate>
                </h2>
                <div class="search-filters flex-container align-center align-middle">
                    <label v-for="(resultType, index) in Object.keys(results)" :key="`result-type-${index}`">
                        <input v-model="selectedTypes" type="checkbox" :id="`check-${resultType}`" :name="`check-${resultType}`" :value="resultType" />
                        <span class="noselect">{{ docTypeLabels[resultType] }} ({{ results[resultType].length }})</span>
                    </label>
                </div>
            </div>
            <div class="cell search-results-category" v-for="(resultType, index) in Object.keys(results)" :key="`category-${index}`" v-if="selectedTypes.length === 0 || selectedTypes.indexOf(resultType) > -1">
                <h3 class="h2 search-results-category-title">{{ docTypeLabels[resultType] }} ({{ results[resultType].length }})</h3>
                <div class="search-results-category-wrapper ">
                    <search-result @close="close" v-for="(result, j) in results[resultType]" :key="`result-${index}-${j}`" :result="result" :result-type="resultType"></search-result>
                </div>
            </div>
            <div class="cell flex-container align-center" v-if="resultsCount > 0">
                <!-- TODO: Faire la page de résultats de recherche -->
                <!-- <router-link class="btn btn-link" :to="{ name: localizedRoute('Home') }">View all results</router-link> -->
            </div>
            <bmr-no-results v-else></bmr-no-results>
        </div>
        <bmr-spinner :center="true" v-else></bmr-spinner>
    </div>
</template>

<script>
import SearchResult from '@/components/partials/SearchResult';

export default {
    components: { SearchResult },
    props: ['keyword'],
    data () {
        return {
            selectedTypes: [],
            results: {},
            loading: false,
            resultsCount: 0,
        };
    },
    computed: {
        docTypeLabels () {
            return {
                'news_articles': this.$gettext('News'),
                'contacts': this.$gettext('Contacts'),
                'activities': this.$gettext('Activities'),
                'notices': this.$gettext('Notices'),
                'bookings': this.$gettext('Bookings'),
                'pages': this.$gettext('Pages'),
            };
        }
    },
    watch: {
        keyword () {
            let value = this.keyword;
            setTimeout(() => {
                if (this.keyword === value) {
                    this.search();
                }
            }, 150);
        }
    },
    mounted () {
        this.search();
        document.body.style.setProperty('overflow', 'hidden');
        document.body.style.setProperty('max-height', '100vh');
    },
    destroyed () {
        document.body.style.removeProperty('overflow');
        document.body.style.removeProperty('max-height');
    },
    methods: {
        search () {
            this.loading = true;
            this.axios.get('api/search/', { params: { search: this.keyword }}).then(response => {
                this.results = response.data || {};

                let resultsKeys = Object.keys(this.results);
                this.resultsCount = resultsKeys.length ? resultsKeys.map(x => this.results[x].length).reduce((total, num) => total + num, 0) : 0;
            }).finally(() => {
                this.loading = false;
            });
        },
        close () {
            this.$emit('close');
        }
    },
};
</script>

<style lang="scss" scoped>
h2 {
    @include rem-typo(32px);
}
a {
    text-decoration: none;
}
.search-filters {
    flex-wrap: wrap;
}
.search-results {
    position: absolute;
    left: 0;
    right: 0;
    top: 100%;
    height: calc(100vh - 97px);
    background: transparentize($black, 0.06);
    color: $white;
    z-index: 99;
    padding: 50px 0;
    overflow: auto;
    @include breakpoint(medium) {
        transform: translateY(-40px);
    }
}
.search-results-category-title {
    color: $color-dove-grey;
}
label {
    margin: 0 12px;
}
input[type="checkbox"] {
    margin: 0 5px 0 0;
}
.btn {
    font-weight: 700;
}
</style>



// WEBPACK FOOTER //
// src/components/partials/SearchResults.vue